module.exports = __webpack_public_path__ + "static/media/reportPageIcon.29e72e23.svg";